import actionTypes from '../actions/types';

export const INITIAL_STATE = null;

export default function globalError(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case actionTypes.THROW_GLOBAL_ERROR: {
      const { statusCode, body } = action.payload || {};

      return { statusCode, body };
    }

    case actionTypes.DISMISS_GLOBAL_ERROR: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
}
